import { useState, useContext } from "react";
import {
  getLocalGovernments,
  fetchStates,
} from "../../../services/nigerian-states";
import { verifyBusiness, verifyBvn } from "../../../services/kyb-verification";
import { ToastContext, RequestLoader } from "../../../hooks/context";

const LimitedLiabilityKybLogic = ({ verificationData, navigation }) => {
  const [business_category, setBusinessCategory] = useState(
    verificationData?.business_category || "",
  );
  const [business_description, setBusinessDescription] = useState(
    verificationData?.business_description || "",
  );
  const [brand_name, setBrandName] = useState(
    verificationData?.business_name || "",
  );
  const [business_state, setBusinesState] = useState(
    verificationData?.state || "",
  );
  const [business_lga, setBusinessLga] = useState(verificationData?.lga || "");
  const [business_address, setBusinessAddress] = useState(
    verificationData?.address || "",
  );
  const [cac_reg_number, setCacRegNumber] = useState(
    verificationData?.cac_rc_number || "",
  );
  const [tax_id_number, setTaxIdNumber] = useState(verificationData?.tin || "");
  const [directors_bvn, setDirectorsBvn] = useState(
    verificationData?.bvn_is_verified ? verificationData?.bvn : "",
  );
  const [govt_id, setGovtId] = useState(
    verificationData?.government_issued_id || "",
  );
  const [utility_bill, setUtilityBill] = useState(
    verificationData?.utility_bill || "",
  );
  const [inc_date, setIncDate] = useState(verificationData?.inc_date || "");

  const [agree_terms, setAgreeTerms] = useState(
    verificationData?.terms_accepted || false,
  );
  const [Incorporation_cert, setIncorporationCert] = useState(
    verificationData?.certificate_of_incorporation || "",
  );
  const [memorandom_cert, setMemorandomCert] = useState(
    verificationData?.memorandum_and_articles_of_association || "",
  );
  const [director_particulars, setDirectorParticulars] = useState(
    verificationData?.particulars_of_directors || "",
  );
  const [showBankVerificationOtpWidget, setShowBankVerificationOtpWidget] =
    useState(false);
  const [isVerifyingAccount, setIsVerifyingAccount] = useState(false);
  const [isVerifyingBvn, setIsVerifyingBvn] = useState(false);
  const [isOpenAgreementModal, setIsOpenAgreementModal] = useState(false);
  const triggerToast = useContext(ToastContext);
  const { setRequestLoaderProgress } = useContext(RequestLoader);

  // TODO: Remove this list and replace with category list later.
  const business_categories = [
    "supermarket",
    "Pharmacy",
    "Restaurant",
    "Bar",
    "Grocery",
    "Hotel",
    "Spa",
    "Technology/IT",
    "Fashion",
    "Others",
  ];

  const handleVerifyAccount = () => {
    if (!verificationData?.bvn_is_verified)
      return triggerToast(
        "Please ensure you have verified your BVN before proceeding",
        "warning",
      );
    setIsVerifyingAccount(true);
    verifyBusiness({
      cac_rc_number: cac_reg_number,
      tin: tax_id_number,
      inc_date: inc_date,
      business_name: brand_name,
      business_type: "LLC",
      business_description: business_description,
      business_category: business_category,
      terms_accepted: agree_terms,
      state: business_state,
      lga: business_lga,
      address: business_address,
    })
      .then(() => {
        setRequestLoaderProgress(100);
        setIsVerifyingAccount(false);
        navigation.next();
        triggerToast("Account successfully verified", "success");
      })
      .catch((error) => {
        setRequestLoaderProgress(100);
        setIsVerifyingAccount(false);
      });
  };

  const handleVerifyBvn = (bvn_number) => {
    setIsVerifyingBvn(true);
    setRequestLoaderProgress(40);
    verifyBvn({ bvn: bvn_number })
      .then(() => {
        setIsVerifyingBvn(false);
        setRequestLoaderProgress(100);
        setShowBankVerificationOtpWidget(true);
      })
      .catch((error) => {
        setIsVerifyingBvn(false);
        setRequestLoaderProgress(100);
      });
  };

  // const uploadBusinessLogo = (document) => {
  //     setRequestLoaderProgress(50);

  //     const formData = new FormData();
  //     formData.append("type", document.type);
  //     formData.append("file", document.file);

  //     uploadImage(formData)
  //         .then((response) => {
  //             setBusinessLogo(response.data.data.url);
  //             setRequestLoaderProgress(100);
  //             triggerToast("Document successfully uploaded", "success");
  //         })
  //         .catch((error) => {
  //             setRequestLoaderProgress(100);
  //
  //
  //         });
  // };

  return {
    business_category,
    business_description,
    brand_name,
    business_state,
    business_lga,
    business_address,
    cac_reg_number,
    tax_id_number,
    directors_bvn,
    // business_logo,
    inc_date,
    agree_terms,
    showBankVerificationOtpWidget,
    isVerifyingAccount,
    isVerifyingBvn,
    business_categories,
    nigerian_states: fetchStates() || [],
    local_government_areas: getLocalGovernments(business_state),
    director_particulars,
    Incorporation_cert,
    memorandom_cert,
    verification_status:
      verificationData?.verification_status === "pending_review" ||
      verificationData?.verification_status === "verified",
    govt_id,
    isOpenAgreementModal,
    utility_bill,
    setUtilityBill,
    setIsOpenAgreementModal,
    setGovtId,
    setIncorporationCert,
    setMemorandomCert,
    setDirectorParticulars,
    setShowBankVerificationOtpWidget,
    setIncDate,
    setBusinessCategory,
    setBusinessDescription,
    setBrandName,
    setBusinesState,
    setBusinessLga,
    setBusinessAddress,
    setCacRegNumber,
    setTaxIdNumber,
    setDirectorsBvn,
    // setBusinessLogo,
    setAgreeTerms,
    handleVerifyBvn,
    handleVerifyAccount,
    // uploadBusinessLogo,
  };
};

export default LimitedLiabilityKybLogic;
